var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal-card-body"},[_c('VideoCarousel',{attrs:{"items":_vm.carousels,"current-item":_vm.currentItem,"public-path":_vm.publicPath},on:{"carousel-item-changed":_vm.handleCarouselItemChanged}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }